import api from "./api";

export async function signupRestaurant(idToken, fullName) {

    const response = await api.post(
        "/api/v1/auth/restaurant/signup",
        {
            idToken,
            ...(fullName && { fullName }),
        }
    );

    return response.data;

}

export async function loginRestaurant(idToken) {

    try {

        const response = await api.post(

            "/api/v1/auth/nextgo/restaurant/login",

            {

                idToken,

            }

        );

        return response.data;

    }

    catch (error) {

        console.error(

            "Restaurant login failed:",

            error

        );

        throw error;

    }

}

export async function logoutRestaurant() {
    try {
        const response = await api.post(
            "/api/v1/auth/restaurant/logout"
        );

        return response.data;
    } catch (error) {
        console.error("Restaurant logout failed:", error);
        throw error;
    }
}